import { v4 as uuidv4 } from "uuid";
import { SelectOption } from "@/components/shared/select";

const editableTableFieldTypes = [
  "text",
  "number",
  "select",
  "multiselect",
] as const;
export type EditableTableFieldType = (typeof editableTableFieldTypes)[number];

export interface EditableTableField {
  key: string;
  label: string;
  type: EditableTableFieldType;
  placeholder?: string;
  options?: SelectOption[];
  required?: boolean;
  width?: string;
}

export interface EditableTableRow {
  id: string;
  [key: string]: any;
  enabled: boolean;
}

export function generateRowId() {
  return `row_${uuidv4()}`;
}

export function buildRows(
  value: EditableTableRow[],
  fields: EditableTableField[]
): EditableTableRow[] {
  const rowsWithIds = value.map((row) => ({
    ...row,
    id:
      row.id || `row_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
  }));

  // If no rows, add one empty row
  if (rowsWithIds.length === 0) {
    const emptyRow: EditableTableRow = {
      id: `row_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      enabled: true,
    };
    fields.forEach((field) => {
      emptyRow[field.key] = "";
    });
    rowsWithIds.push(emptyRow);
  }

  return rowsWithIds;
}
